import type { FC } from '../../lib/teact/teact';
import React, { useState } from '../../lib/teact/teact';
import { getActions } from '../../global';

import Button from '../ui/Button';

import './UnauthorizedLogin.scss';

const UnauthorizedLogin: FC = () => {
  const { goToAuthQrCode, returnToAuthPhoneNumber } = getActions();
  const [isLoading, setIsLoading] = useState(false);

  const handleLoginClick = async () => {
    setIsLoading(true);
    
    // Add a small delay to show the loading state
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Use QR code login for desktop, phone number for mobile
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      returnToAuthPhoneNumber();
    } else {
      goToAuthQrCode();
    }
  };

  return (
    <div className="unauthorized-login">
      <div className="unauthorized-login__container">
        <div className="unauthorized-login__content">
          <h1 className="unauthorized-login__title">TCommander</h1>
          <p className="unauthorized-login__subtitle">
            Your Telegram management dashboard
          </p>
          <Button
            className="unauthorized-login__button"
            size="large"
            isLoading={isLoading}
            onClick={handleLoginClick}
          >
            Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedLogin;
